import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BookingContextService } from '../../services/booking-context.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { LoadingDialogService } from '../../../../shared/ui/loading/loading-dialog.service';


@Component({
    selector: 'app-booking-activation-required-dialog',
    templateUrl: './booking-activation-required-dialog.component.html',
    styleUrls: ['./booking-activation-required-dialog.component.css'],
    standalone: false
})
export class BookingActivationRequiredDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<BookingActivationRequiredDialogComponent>,
    private router: Router,
    private bookingContextService: BookingContextService,
    private notification: NotificationService,
    private loading: LoadingDialogService
  ) { }

  canStartTrial = false;
  trialUsed = false;
  isStarting = false;
  trialEndDate: Date | null = null;

  ngOnInit(): void {
    this.bookingContextService.getBookingMerchantStatus().subscribe({
      next: response => {
        const value = response && response.isSuccess ? response.value : null;

        if (value && value.canStartTrial) {
          this.canStartTrial = true;
          this.trialEndDate = value.trialEndDate ? new Date(value.trialEndDate) : null;
        }

        this.trialUsed = !!(value && value.trialUsed);
      },
      error: () => null
    });
  }

  get trialEndLabel(): string {
    return this.trialEndDate
      ? this.trialEndDate.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })
      : '';
  }

  private startTrial(): void {
    this.isStarting = true;
    this.dialogRef.disableClose = true;

    this.loading.run('Activando tu prueba de Reservas PRO…', this.bookingContextService.startBookingTrial())
      .then(response => {
        if (response && response.isSuccess) {
          this.notification.ok('Prueba de Reservas PRO activada');
          this.dialogRef.close();
          window.location.reload();
          return;
        }

        this.failTrial();
      })
      .catch(() => this.failTrial());
  }

  private failTrial(): void {
    this.isStarting = false;
    this.dialogRef.disableClose = false;
    this.notification.error('No se ha podido activar la prueba. Inténtalo de nuevo.');
  }

  onClose(): void {
    this.router.navigate(['/resume']);
    this.dialogRef.close();
  }

  onActivate(): void {
    if (this.canStartTrial) {
      this.startTrial();
      return;
    }

    this.router.navigate(['/subscription'], { queryParams: { activateBooking: 'true' } });
    this.dialogRef.close();
  }
}
